/**
 * Created by mac on 4/16/22
 */

const ManualStarters = {
    ChildStarter: function (parent) {
        return function () {
            return cleverapps.missionManager.findByType(parent);
        };
    },

    FogStarter: function (type) {
        return Missions[type].startFog && Map2d.currentMap.fogs.isOpened(Missions[type].startFog);
    },

    UnitStarter: function (type) {
        return Missions[type].startUnit && cleverapps.unitsLibrary.isOpened(Missions[type].startUnit);
    }
};
